<template>
  <div class="page-column">
    <Swiper></Swiper>
    <NewsAgencyRanking></NewsAgencyRanking>
    <PlayerRanking></PlayerRanking>
    <NewestMatch></NewestMatch>
    <!-- <Sponser></Sponser> -->
  </div>
</template>

<script>
import Swiper from './Swiper.vue'
import NewsAgencyRanking from './NewsAgencyRanking'
import PlayerRanking from './PlayerRanking'
import NewestMatch from './NewestMatch'
import Sponser from './Sponser'
export default {
  components: {
    Swiper,
    NewsAgencyRanking,
    PlayerRanking,
    NewestMatch,
    Sponser
  },
  data () {
    return {
      info: {}
    }
  },
  created () {
    window.scrollTo(0, 0)
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
.page-column {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
}

</style>



// WEBPACK FOOTER //
// src/daoba-match/views/event/home/HomeIndex.vue